@import '../../../constants/spacing.module.less';

.cost-review-line {
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  gap: @space-8;
  padding: 10px 35px;
  border: 1px solid transparent;

  color: var(--default--text-color--9);
  font-size: 14px;
  line-height: 20px;
}
